import React from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

export default function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => queryString.parse(search), [search]);
}
